import { v4 as uuidv4 } from 'uuid';
import Clarity from '@microsoft/clarity';

const projectId = process.env.VUE_APP_CLARITY_PROJECT_ID;
let currentSessionId: string | null = null;

export default {
    install(Vue: any) {
        if (!projectId) {
            console.error('Clarity Project ID is not defined. Please set VUE_APP_CLARITY_PROJECT_ID in your environment variables.');
            return;
        }

        Clarity.init(projectId);
        currentSessionId = uuidv4();

        Vue.prototype.$clarity = Clarity;

        Vue.prototype.$getSessionInfo = function() {
            // Clarity doesn't expose a session replay URL directly.
            // We'll have to construct it if needed, or handle it on the frontend when displaying.
            // For now, sending null for sessionReplayUrl.
            // Distinct ID in PostHog is similar to a user ID.
            return {
                sessionId: currentSessionId,
                sessionReplayUrl: null, 
                distinctId: null, // Clarity's identify is separate. The distinctId is usually for anonymous users.
                provider: 'clarity'
            };
        };

        Vue.prototype.$identifyUser = function(userId: string, userProperties?: any) {
            if (currentSessionId) {
                Clarity.identify(userId, currentSessionId, undefined, userProperties?.name);
                if (userProperties) {
                    // You can use custom tags for other properties
                    Object.entries(userProperties).forEach(([key, value]) => {
                        if (typeof value === 'string' || Array.isArray(value)) {
                             Clarity.setTag(key, value as string | string[]);
                        }
                    });
                }
            }
        };
    }
}; 